export const testIds = {
  createErrorBudgetButton: 'create-error-budget-chart',
  createBurnRateButton: 'create-burn-rates-chart',
  createSignalFxChartButton: 'create-signalfx-chart',
};
